/* Footer accordion gate. The footer columns switch between a static desktop
 * list and a mobile accordion at the SITEWIDE 1265px breakpoint. Horizon's
 * accordion-custom primitive cannot express that — its desktop gate is
 * hardwired to 750px (assets/accordion-custom.js via @theme/utilities) — so
 * the columns render a plain <details> and this script owns the behavior:
 * at >=1265px every panel stays open and the summary is inert; below,
 * each column is a real accordion whose default open state comes from the
 * wrapper's data-open-on-mobile attribute (the merchant's block setting).
 * With no JS at all, the hardcoded `open` attribute leaves every panel
 * visible, which is the safe fallback. */
(() => {
  const desktop = window.matchMedia('(min-width: 1265px)');

  /* Page-lifetime listeners; the signal exists so a future teardown (or a
   * test harness) can abort them all in one call. */
  const { signal } = new AbortController();

  const applyDefaults = () => {
    for (const column of document.querySelectorAll('.twc-footer__column')) {
      const details = column.querySelector('details');
      if (!details) continue;
      details.open = desktop.matches || column.hasAttribute('data-open-on-mobile');
    }
  };

  /* Delegated so theme-editor section re-renders keep working without
   * re-binding; shopify:section:load re-applies the default state. */
  document.addEventListener(
    'click',
    (event) => {
      if (!desktop.matches) return;
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.twc-footer__column summary')) event.preventDefault();
    },
    { signal }
  );

  desktop.addEventListener('change', applyDefaults, { signal });
  document.addEventListener('shopify:section:load', applyDefaults, { signal });
  applyDefaults();
})();
